import type { User } from '@/types';

/**
 * /api/users/me returns `warehouseAssignments` (array). The frontend's
 * usePermissions reads `user.warehouseRoles` (a Record keyed by warehouseId).
 * Without this derivation, every non-admin's roles array would be empty and
 * canAccess would deny every route except ANY_AUTHENTICATED — leaving managers
 * seeing only the dashboard and notifications.
 */
export function withWarehouseRoles(u: User): User {
  return {
    ...u,
    warehouseRoles: Object.fromEntries(
      (u.warehouseAssignments ?? []).map((a) => [a.warehouseId, a.roles]),
    ),
  };
}
